module.exports = __webpack_public_path__ + "img/KSC04305.589ec6fe.jpg";